import { useAgentRunUiState, type AgentRunActivityState, type EditorState } from '@/hooks/llm/use-llm-agent';

export type AgentSessionState = {
  isLoading: boolean;
  currentStep: string | null;
  isNetworkError: boolean;
  activityState: AgentRunActivityState;
  editorState: EditorState;
  isWriting: boolean;
  isReviewing: boolean;
  isInteractive: boolean;
};

export const useAgentSessionState = (requestId?: string): AgentSessionState => {
  const { isLoading, currentStep, isNetworkError, editorState, activityState } = useAgentRunUiState(requestId);

  return {
    isLoading,
    currentStep,
    isNetworkError,
    activityState,
    editorState,
    isWriting: editorState === 'agent_writing',
    isReviewing: editorState === 'review',
    isInteractive: editorState === 'interactive',
  };
};
